import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { validateStep8 } from './validations';

import { Field } from 'redux-form';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import CheckboxGroup from '../CheckboxGroup';
import DropDownSelect from '../DropDownSelect';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupFull
} from '../../containers/DefaultStyles/FormDetails';

import { LoadingSpinner } from '../../components/LoadingSpinner';

class VoteRegistrationStep8Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = { class: 'default' };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange() {
        this.setState({ class: 'changed' });
    }

    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupFull>
                    <Field
                        name={
                            this.props.infoTextRaceRequired ? 'race' : 'raceNotRequired'
                        }
                        component={DropDownSelect}
                        options={this.props.races}
                        defaultOption={'Choose'}
                        label="Race"
                        type="text"
                        infoText={this.props.infoTextRace}
                        onChange={this.handleChange}
                        class={this.state.class}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        name={
                            this.props.infoTextPartyRequired
                                ? 'party'
                                : 'partyNotRequired'
                        }
                        component={DropDownSelect}
                        options={this.props.parties}
                        defaultOption={'Choose'}
                        label="Party"
                        type="text"
                        infoText={this.props.infoTextParty}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        name="partnerOptInVolunteer"
                        component={CheckboxGroup}
                        label="Want to opt in to volunteer with Rock the Vote?"
                        normalize={v => !!v}
                    />
                </MultipleGroupFull>
                <ButtonGroupWrapper
                    isFormSubmitting={this.props.isFormSubmitting}
                    rightPosition={23}
                >
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Prepare Form"
                            className="submitButton"
                            disabled={this.props.invalid}
                            isSubmitting={this.props.isFormSubmitting}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep8Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    infoTextRace: PropTypes.string,
    infoTextRaceRequired: PropTypes.bool,
    infoTextParty: PropTypes.string,
    infoTextPartyRequired: PropTypes.bool,
    parties: PropTypes.array,
    races: PropTypes.array,
    isFormSubmitting: PropTypes.bool
};

export default compose(
    connect(() => ({
        initialValues: {}
    })),
    reduxForm({
        form: 'voteRegistrationStep8Form',
        validate: validateStep8,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep8Form);



// WEBPACK FOOTER //
// ./src/components/VoteRegistration/VoteRegistrationStep8Form.jsx